import React from 'react';
import './styles.css';

function InstagramLink() {
  return (
    <div className="symbol">
      <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/asmrchurch/">
        <img
          src={`${process.env.PUBLIC_URL}/static/images/instagram.svg`}
          alt="Instagram"
          width="50"
          height="50"
        />
      </a>
    </div>
  );
}

function FacebookLink() {
  return (
    <div className="symbol">
      <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=61593980265405">
        <img
          src={`${process.env.PUBLIC_URL}/static/images/facebook.svg`}
          alt="Facebook"
          width="50"
          height="50"
        />
      </a>
    </div>
  );
}

function SuzuriLink() {
  return (
    <div className="symbol">
      <a target="_blank" rel="noopener noreferrer" href="https://suzuri.jp/asmrchurch2">
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="50" viewBox="0 0 100 50" role="img" aria-label="SUZURI">
          <rect width="100" height="50" rx="8" fill="#fff" />
          <path d="M43 7h14l7 5-5 7-3-2v12H44V17l-3 2-5-7Z" fill="none" stroke="#222" strokeWidth="2" strokeLinejoin="round" />
          <text x="50" y="43" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="700" letterSpacing="2" fill="#222">SUZURI</text>
        </svg>
      </a>
    </div>
  );
}

function Ad() {
  const noticePdfUrl = 'https://www.asmrchurch.com/static/pdf/ncc-protest-statement.pdf';
  const lineStickerUrl = 'https://t.co/2i3qn4YexE';

  return (
    <div className="section ad">
      <div style={{ textAlign: 'center', marginBottom: '4px' }}>
        <div style={{ display: 'inline-block', overflow: 'hidden', maxWidth: '100%', lineHeight: 0 }}>
          <img
            src={`${process.env.PUBLIC_URL}/static/images/illustration-20260803.gif`}
            alt="イラスト"
            style={{
              maxWidth: '100%',
              height: 'auto',
              display: 'block',
            }}
          />
        </div>
      </div>
      <div style={{ textAlign: 'center', marginBottom: '4px' }}>
        <a target="_blank" rel="noopener noreferrer" href="https://asmrchurch.fanbox.cc">
          <img
            className="sien-top-banner"
            src={`${process.env.PUBLIC_URL}/static/images/sien.png`}
            alt="Fanbox（支援はこちら）"
            style={{ maxWidth: '100%', height: 'auto', display: 'block', margin: '0 auto' }}
          />
        </a>
      </div>
      <div className="">
        <div className="amensec">
        </div>
        <div>
          {/*
          <stripe-buy-button
            buy-button-id="buy_btn_1QiEyXJrEFc0aoshZrg6uGA0"
            publishable-key="pk_live_51L77y9JrEFc0aoshDbT8faRDJBWQJjQTGvMb6jngK3GGGpMtIYf8omncPkMd8e0be0ZsfG2yEWaxYdMSlGSS9pgX00RNzmWvfw"
          >
          </stripe-buy-button>
          */}
        </div>
        <div>
          <a target="_blank" rel="noopener noreferrer" href="/characters">
            キャラクター紹介
          </a>
        </div>
        <div>
          <a href="/article/3">
            使徒信条
          </a>
        </div>
        <div>
          <a href="/article/4">
            主の祈り
          </a>
        </div>
        <div>
          <a target="_blank" rel="noopener noreferrer" href="/wiki">
            聖書ASMRウィキ
          </a>
        </div>
        <div>
          <a target="_blank" rel="noopener noreferrer" href="/article/1">
            いのちのASMR電話
          </a>
        </div>
        <div>
          <a target="_blank" rel="noopener noreferrer" href="/caption">
            コスパ名言集
          </a>
        </div>
        <div>
          <a href="/fanart">ファンアート</a>
        </div>
        <div>
          <a target="_blank" rel="noopener noreferrer" href={noticePdfUrl}>
            NCCへの抗議声明
          </a>
        </div>
        <div>
          <a href="/kirikan-guideline">
            キリ看ちゃん二次利用ガイドライン
          </a>
        </div>
      </div>

      <div className="symbols">
        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href="https://www.dlsite.com/home/fsr/=/title_id/SRI0000035120/order/title_d/from/work.titles/ana_flg/all">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/dlsite.png`}
              alt="dlsite"
              style={{ height: '50px' }}
            />
          </a>
        </div>

        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href="https://www.pixiv.net/en/users/107379276">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/pixiv.png`}
              alt="pixiv"
              style={{ height: '50px' }}
            />
          </a>
        </div>

        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href="https://www.tiktok.com/@sexybible">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/tiktok.png`}
              alt="tiktok"
              style={{ height: '50px' }}
            />
          </a>
        </div>

        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href="https://asmrchruch.bandcamp.com/">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/bandcamp.png`}
              alt="bandcamp"
              style={{ height: '70px' }}
            />
          </a>
        </div>

        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href="https://discord.com/invite/wpwSjjnSs8">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/discord.png`}
              alt="discord"
              style={{ height: '70px' }}
            />
          </a>
        </div>

        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href="https://x.com/asmrchurch">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/x.png`}
              alt="x"
              style={{ height: '70px' }}
            />
          </a>
        </div>

        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href="https://podcasts.apple.com/us/podcast/asmrキリスト教会/id1772229960">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/podcast.png`}
              alt="podcast"
              style={{ height: '50px' }}
            />
          </a>
        </div>

        <InstagramLink />
        <FacebookLink />
        <SuzuriLink />

        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href="https://note.com/asmrchurch">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/note.png`}
              alt="note"
              style={{ height: '50px' }}
            />
          </a>
        </div>

        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/jp/app/%E5%8F%A3%E8%AA%9E%E8%A8%B3%E8%81%96%E6%9B%B8-asmr%E3%82%AD%E3%83%AA%E3%82%B9%E3%83%88%E6%95%99%E4%BC%9A/id6747372843">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/ios.jpg`}
              alt="iOS App"
              style={{ width: '100%' }}
            />
          </a>
        </div>
        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href={lineStickerUrl}>
            <img
              src={`${process.env.PUBLIC_URL}/static/images/kirikan-line-sticker-card.jpg`}
              alt="きりかんちゃん LINE スタンプ"
              style={{ width: '100%' }}
            />
          </a>
        </div>
        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href="https://www.kirishin.com/2024/05/19/66663/">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/kirishin.jpeg`}
              alt="kirishin"
              style={{ width: '100%' }}
            />
          </a>
        </div>
        <div className="symbol">
          <a target="_blank" rel="noopener noreferrer" href="https://tokyo-nic.com/">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/tnic.jpg`}
              alt="Tokyo NIC"
              style={{ width: '100%' }}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

// AdIcons - Reusable icons component
export function AdIcons() {
  const lineStickerUrl = 'https://t.co/2i3qn4YexE';

  return (
    <div className="symbols">
      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href="https://www.dlsite.com/home/fsr/=/title_id/SRI0000035120/order/title_d/from/work.titles/ana_flg/all">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/dlsite.png`}
            alt="dlsite"
            style={{ height: '50px' }}
          />
        </a>
      </div>

      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href="https://www.pixiv.net/en/users/107379276">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/pixiv.png`}
            alt="pixiv"
            style={{ height: '50px' }}
          />
        </a>
      </div>

      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href="https://www.tiktok.com/@sexybible">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/tiktok.png`}
            alt="tiktok"
            style={{ height: '50px' }}
          />
        </a>
      </div>

      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href="https://asmrchruch.bandcamp.com/">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/bandcamp.png`}
            alt="bandcamp"
            style={{ height: '70px' }}
          />
        </a>
      </div>

      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href="https://discord.com/invite/wpwSjjnSs8">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/discord.png`}
            alt="discord"
            style={{ height: '70px' }}
          />
        </a>
      </div>

      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href="https://x.com/asmrchurch">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/x.png`}
            alt="x"
            style={{ height: '70px' }}
          />
        </a>
      </div>

      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href="https://podcasts.apple.com/us/podcast/asmrキリスト教会/id1772229960">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/podcast.png`}
            alt="podcast"
            style={{ height: '50px' }}
          />
        </a>
      </div>

      <InstagramLink />
      <FacebookLink />
      <SuzuriLink />

      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href="https://note.com/asmrchurch">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/note.png`}
            alt="note"
            style={{ height: '50px' }}
          />
        </a>
      </div>

      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/jp/app/%E5%8F%A3%E8%AA%9E%E8%A8%B3%E8%81%96%E6%9B%B8-asmr%E3%82%AD%E3%83%AA%E3%82%B9%E3%83%88%E6%95%99%E4%BC%9A/id6747372843">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/ios.jpg`}
            alt="iOS App"
            style={{ width: '100%' }}
          />
        </a>
      </div>
      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href={lineStickerUrl}>
          <img
            src={`${process.env.PUBLIC_URL}/static/images/kirikan-line-sticker-card.jpg`}
            alt="きりかんちゃん LINE スタンプ"
            style={{ width: '100%' }}
          />
        </a>
      </div>
      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href="https://www.kirishin.com/2024/05/19/66663/">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/kirishin.jpeg`}
            alt="kirishin"
            style={{ width: '100%' }}
          />
        </a>
      </div>
      <div className="symbol">
        <a target="_blank" rel="noopener noreferrer" href="https://tokyo-nic.com/">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/tnic.jpg`}
            alt="Tokyo NIC"
            style={{ width: '100%' }}
          />
        </a>
      </div>

    </div>
  );
}

export default Ad;
